import React from "react";
import { Swipeable, defineSwipe } from "react-touch";

const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);

/**
 * Componente de fadein, todos os componentes que são filhos desse
 * serão renderizados inicialmente com um fade-in.
 */
export default class ApiceFadeIn extends React.Component {
  constructor() {
    super();
    this.state = {
      ...this.state,
      visivel: false,
    };
  }

  /**
   * Retorna o classname da div principal
   */
  getClassName() {
    return this.state.visivel
      ? "opacity-1 trans-03s h-100 "
      : "opacity-0 trans-03s h-100 ";
  }

  /**
   * Faz a tela aparecer
   */
  fadeIn() {
    setTimeout(() => {
      this.setState({ visivel: true });
    }, 50);
  }

  /**
   * Faz a tela desaparecer
   */
  fadeOut() {
    this.setState({ visivel: false });
  }

  render() {
    const swipe = defineSwipe({ swipeDistance: 20 });
    return (
      <Swipeable
        config={swipe}
        onSwipeLeft={() => {
          const open = document.body.className.search("sidebar-open") > 0;
          if (open && !isMobile) {
            document.body.className = document.body.className.replace(
              "sidebar-open",
              ""
            );
          }
        }}
        onSwipeRight={() => {
          const open = document.body.className.search("sidebar-open") > 0;
          if (!open && !isMobile) {
            document.body.className = document.body.className + " sidebar-open";
          }
        }}
      >
        <div
          className={this.getClassName() + " " + this.props.className}
          style={this.props.style}
        >
          {this.props.children}
        </div>
      </Swipeable>
    );
  }
}



// WEBPACK FOOTER //
// ./src/lib_react_frontend/componentes/ApiceFadeIn.jsx